import Product from './Product';

export default class DynamicProduct extends Product {
  constructor(section) {
    super(section, { useHistory: false });
  }
}
